export const colors = {
  // Brand — frames the web app to match Olio's marketing brand
  brandNavy100: '#161D49',
  brandNavy75: 'rgba(22, 29, 73, .75)',
  brandNavy50: 'rgba(22, 29, 73, .50)',
  brandNavy25: 'rgba(22, 29, 73, .25)',
  brandNavy10: 'rgba(22, 29, 73, .10)',
  brandNavy5: 'rgba(22, 29, 73, .05)',
  brandNavy3: 'rgba(22, 29, 73, .03)',

  brandYellow100: '#FDF854',
  brandYellow75: 'rgba(253, 248, 84, .75)',
  brandYellow50: 'rgba(253, 248, 84, .50)',
  brandYellow25: 'rgba(253, 248, 84, .25)',
  brandYellow10: 'rgba(253, 248, 84, .10)',
  brandYellow5: 'rgba(253, 248, 84, .05)',
  brandYellow3: 'rgba(253, 248, 84, .03)',

  // Base — backgrounds, text and component elements
  white: '#FFFFFF',
  white90: 'rgba(255, 255, 255, .9)',
  white75: 'rgba(255, 255, 255, .75)',
  white50: 'rgba(255, 255, 255, .5)',
  white25: 'rgba(255, 255, 255, .25)',
  white10: 'rgba(255, 255, 255, .1)',
  white5: 'rgba(255, 255, 255, .05)',
  white3: 'rgba(255, 255, 255, .03)',
  black100: '#090F25',
  black75: 'rgba(9, 15, 37, .75)',
  black50: 'rgba(9, 15, 37, .50)',
  black25: 'rgba(9, 15, 37, .25)',
  black10: 'rgba(9, 15, 37, .10)',
  black5: 'rgba(9, 15, 37, .05)',
  black3: 'rgba(9, 15, 37, .03)',

  // Primary — page structure, CTAs (buttons and links)
  blueExtraDark: '#133049',
  blueHover: '#274E90',
  blue100: '#317FC2',
  blue75: 'rgba(49, 127, 194, .75)',
  blue50: 'rgba(49, 127, 194, .50)',
  blue25: 'rgba(49, 127, 194, .25)',
  blue10: 'rgba(49, 127, 194, .10)',
  blue5: 'rgba(49, 127, 194, .05)',
  blue3: 'rgba(49, 127, 194, .03)',

  // Secondary — clinical statuses, data visualization, validation and styled elements
  greenExtraDark: '#193418',
  greenHover: '#2B5530',
  green100: '#4C9C49',
  green75: 'rgba(76, 156, 73, .75)',
  green50: 'rgba(76, 156, 73, .50)',
  green25: 'rgba(76, 156, 73, .25)',
  green10: 'rgba(76, 156, 73, .10)',
  green5: 'rgba(76, 156, 73, .05)',
  green3: 'rgba(76, 156, 73, .03)',

  redExtraDark: '#641626',
  redHover: '#91243A',
  red100: '#D4405E',
  red75: 'rgba(212, 64, 94, .75)',
  red50: 'rgba(212, 64, 94, .50)',
  red25: 'rgba(212, 64, 94, .25)',
  red10: 'rgba(212, 64, 94, .10)',
  red5: 'rgba(212, 64, 94, .05)',
  red3: 'rgba(212, 64, 94, .03)',

  yellowExtraDark: '#4D3100',
  yellowHover: '#915308',
  yellow100: '#E69200',
  yellow75: 'rgba(230, 146, 0, .75)',
  yellow50: 'rgba(230, 146, 0, .50)',
  yellow25: 'rgba(230, 146, 0, .25)',
  yellow10: 'rgba(230, 146, 0, .10)',
  yellow5: 'rgba(230, 146, 0, .05)',
  yellow3: 'rgba(230, 146, 0, .03)',

  purpleExtraDark: '#512376',
  purpleHover: '#603285',
  purple100: '#9F62D0',
  purple75: 'rgba(159, 98, 208, .75)',
  purple50: 'rgba(159, 98, 208, .50)',
  purple25: 'rgba(159, 98, 208, .25)',
  purple10: 'rgba(159, 98, 208, .10)',
  purple5: 'rgba(159, 98, 208, .05)',
  purple3: 'rgba(159, 98, 208, .03)',

  orangeExtraDark: '#5B2A0B',
  orangeHover: '#883E11',
  orange100: '#E3681C',
  orange75: 'rgba(227, 104, 28, .75)',
  orange50: 'rgba(227, 104, 28, .50)',
  orange25: 'rgba(227, 104, 28, .25)',
  orange10: 'rgba(227, 104, 28, .10)',
  orange5: 'rgba(227, 104, 28, .05)',
  orange3: 'rgba(227, 104, 28, .03)',

  lightBlueExtraDark: '#1E616C',
  lightBlueHover: '#28859F',
  lightBlue100: '#53BFD0',
  lightBlue75: 'rgba(83, 191, 208, .75)',
  lightBlue50: 'rgba(83, 191, 208, .50)',
  lightBlue25: 'rgba(83, 191, 208, .25)',
  lightBlue10: 'rgba(83, 191, 208, .10)',
  lightBlue5: 'rgba(83, 191, 208, .05)',
  lightBlue3: 'rgba(83, 191, 208, .03)',

  // Gradient — reserved for "advanced" features and functions (e.g. AI)
  ai: 'linear-gradient(to left, rgba(107, 102, 209, 0.75), #9F62D0)',
  ai25: 'linear-gradient(to left, rgba(107, 102, 209, 0.19), rgba(159, 98, 208, 0.25))',
  ai20: 'linear-gradient(to left, rgba(107, 102, 209, 0.15), rgba(159, 98, 208, 0.2))',
  ai15: 'linear-gradient(to left, rgba(107, 102, 209, 0.11), rgba(159, 98, 208, 0.15))',
  ai10: 'linear-gradient(to left, rgba(107, 102, 209, 0.08), rgba(159, 98, 208, 0.1))',

  // Utility — mechanical/UI values with no direct brand-palette equivalent
  boxShadow: 'rgba(22, 29, 73, 0.1)',
};

export default colors;
